import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
    generalInsurerAll: [],
    generalInsurer: {},
    currentPage: 1,
    totalPages: 1,
    rowsPerPage: 10,
    sortBy: "name",
    sortOrder: "asc",
};

const generalInsurerSlice = createSlice({
    name: "generalInsurer",
    initialState,
    reducers: {
        setGeneralInsurerAll: (state, action) => {
            state.generalInsurerAll = action.payload;
        },
        setGeneralInsurer: (state, action) => {
            state.generalInsurer = action.payload;
        },
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
        setTotalPages: (state, action) => {
            state.totalPages = action.payload;
        },
        setRowsPerPage: (state, action) => {
            state.rowsPerPage = action.payload;
        },
    },
})

export const { setGeneralInsurerAll, setGeneralInsurer, setCurrentPage, setTotalPages, setRowsPerPage } = generalInsurerSlice.actions;
export default generalInsurerSlice.reducer;